import _ from 'lodash';

const getYearRange = (numberOfYearsRange: number) =>
  _.range(new Date().getFullYear() + numberOfYearsRange, new Date().getFullYear() + 1).map(year => ({
    value: year.toString(),
    label: year.toString(),
  }));

export const YEAR_OF_BIRTH_RANGE = getYearRange(-100).reverse();

export const YEAR_OF_EXPIRATION_RANGE = getYearRange(100).reverse();

export const YEAR_OF_REGISTRATION_RANGE = getYearRange(-200).reverse();
